import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BarChartIcon from "@mui/icons-material/BarChart";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HomeIcon from "@mui/icons-material/Home";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import PhotoAlbumIcon from "@mui/icons-material/PhotoAlbum";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import SmsIcon from "@mui/icons-material/Sms";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useState } from "react";
import { useQuery } from "react-query";
import { FaBars, FaChartLine, FaSignOutAlt, FaUserFriends, FaWallet } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import logo1 from "../../../assets/logo.png";
import { apiConnectorGet } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";

const getMenu = (activeMt5Accounts = []) => [
  { title: "Dashboard", icon: <HomeIcon />, path: "/dashboard" },
  {
    title: "Fund Deposit",
    icon: <FaWallet />,
    submenu: [
      { title: "Fund Deposit", icon: <DashboardIcon />, path: "/topup_data" },
      { title: "Deposit History", icon: <PhotoAlbumIcon />, path: "/activation" },
      { title: "Claim Deposit", icon: <DashboardIcon />, path: "/claim_topup" },
      { title: "P2P Transfer", icon: <DashboardIcon />, path: "/fund-transfer-to-topup-wallet" },
      { title: "Transfer History", icon: <BarChartIcon />, path: "/fund-transfer-history" },
      { title: "Topup History", icon: <BarChartIcon />, path: "/topup_history" },
    ],
  },
  {
    title: "Fund Withdrawal",
    icon: <FaWallet />,
    submenu: [
      { title: "Fund Withdrawal", icon: <BarChartIcon />, path: "/with" },
      { title: "Withdrawal Report", icon: <BarChartIcon />, path: "/payout-report" },
    ],
  },
  {
    title: "Network",
    icon: <FaUserFriends />,
    submenu: [
      { title: "Direct Member", icon: <PersonIcon />, path: "/referral" },
      { title: "Team Member", icon: <PersonAddAlt1Icon />, path: "/downline" },
      { title: "Member Tree", icon: <FaChartLine />, path: "/team" },
    ],
  },
  {
    title: "Income",
    icon: <CurrencyExchangeIcon />,
    submenu: [
      { title: "Direct Sponsor Income", icon: <SignalCellularAltIcon />, path: "/income/direct" },
      { title: "Unilevel Income", icon: <CurrencyExchangeIcon />, path: "/income/level" },
      // { title: "ROI Bonus", icon: <CurrencyExchangeIcon />, path: "/income/roi" },
      // { title: "Reward Bonus", icon: <CurrencyExchangeIcon />, path: "/income/reward" },
      { title: "Global Circle Income", icon: <CurrencyExchangeIcon />, path: "/income/salary" },
    ],
  },
  // {
  //   title: "Master Account",
  //   icon: <CurrencyExchangeIcon />,
  //   submenu: [
  //     { title: "Client Accounts", icon: <SignalCellularAltIcon />, path: "/client-accounts" },
  //     { title: "Global Dashboard", icon: <SignalCellularAltIcon />, path: "/global-dashboard" },
  //     { title: "Global Deposit", icon: <SignalCellularAltIcon />, path: "/global-deposit" },
  //     { title: "Global Withdrawal", icon: <CurrencyExchangeIcon />, path: "/global-withdrawal" },
  //     ...activeMt5Accounts.map((item) => ({
  //       title: "MT5- " + item?.m07_ac_no,
  //       icon: <SignalCellularAltIcon />,
  //       path: `/mt5_account?account=${item?.m07_ac_no}`,
  //     })),
  //   ],
  // },
  // { title: "Ticket & Support", icon: <SmsIcon />, path: "/ticket-and-support" },
  // {
  //   title: "Presentation",
  //   icon: <PictureAsPdfIcon />,
  //   submenu: [
  //     {
  //       title: "View",
  //       icon: <PictureAsPdfIcon />,
  //       action: () => window.open(`${window.location.origin}/plan.pdf`, "_blank", "noopener,noreferrer"),
  //     },
  //     {
  //       title: "Download",
  //       icon: <PictureAsPdfIcon />,
  //       action: () => {
  //         const link = document.createElement("a");
  //         link.href = `${window.location.origin}/plan.pdf`;
  //         link.setAttribute("download", "plan.pdf");
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //       },
  //     },
  //   ],
  // },
  { title: "Profile", icon: <AccountCircleIcon />, path: "/profile" },
];

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { data: mt5AccountsApi } = useQuery(
    ["get_mt5_account_admin", "sidebar"],
    () => apiConnectorGet(endpoint?.get_mt5_account_admin),
    { refetchOnMount: false, refetchOnReconnect: false, retry: false, retryOnMount: false, refetchOnWindowFocus: false }
  );

  const mt5Rows = mt5AccountsApi?.data?.result;
  const activeMt5Accounts = (
    Array.isArray(mt5Rows) ? mt5Rows : Array.isArray(mt5Rows?.data) ? mt5Rows?.data : []
  ).filter((item) => Number(item?.m07_ac_status) === 1 && String(item?.m07_ac_no || "").trim());

  const menu = getMenu(activeMt5Accounts);

  const isPathActive = (path) => path && location.pathname === path;
  const isMenuActive = (item) =>
    isPathActive(item.path) || item.submenu?.some((s) => isPathActive(s.path));

  return (
    <>
      {/* ── MOBILE HEADER ── */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 h-14 flex items-center justify-between px-4 border-b border-[#1e3a5f]/60 backdrop-blur-xl"
        style={{ background: "rgba(6,14,28,0.97)" }}>
        <button
          onClick={() => setOpen(true)}
          className="w-9 h-9 rounded-xl flex items-center justify-center border border-[#1e3a5f]/60 hover:border-[#2563EB]/40 hover:bg-[#2563EB]/10 text-[#475569] hover:text-[#7DD3FC] transition-all duration-200"
        >
          <FaBars />
        </button>

        {/* Center brand */}
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#22D3EE]/20 to-[#1D4ED8]/20 border border-[#2563EB]/40 flex items-center justify-center">
            <img src={logo1} alt="logo" className="w-5 h-5 object-contain" />
          </div>
          <span className="text-white font-extrabold text-sm tracking-wide">HEXAFUND</span>
        </div>

        <div className="w-9" />
      </div>

      {/* ── OVERLAY ── */}
      {open && (
        <div onClick={() => setOpen(false)}
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 lg:hidden" />
      )}

      {/* ── SIDEBAR ── */}
      <aside
        className={`fixed lg:sticky lg:top-0 top-0 left-0 z-50 h-screen w-72 flex flex-col
          border-r border-[#1e3a5f]/50 overflow-hidden
          transform transition-transform duration-300 ease-out
          ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
        style={{ background: "linear-gradient(160deg, #060E1C 0%, #080F1C 50%, #0B1E36 100%)" }}
      >
        {/* Background effects */}
        <div className="absolute top-0 right-0 w-48 h-48 bg-[#2563EB]/6 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-36 h-36 bg-[#1D4ED8]/6 rounded-full blur-2xl pointer-events-none" />
        {/* Top accent */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#2563EB]/50 to-transparent" />
        {/* Left accent bar */}
        <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#22D3EE] via-[#2563EB] to-[#1D4ED8]" />

        {/* ── LOGO HEADER ── */}
        <div className="relative z-10 flex items-center justify-between px-5 py-4 border-b border-[#1e3a5f]/40 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="absolute inset-0 bg-[#2563EB]/30 rounded-xl blur-md" />
              <div className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-[#22D3EE]/20 to-[#1D4ED8]/20 border border-[#2563EB]/40 flex items-center justify-center">
                <img src={logo1} alt="logo" className="w-6 h-6 object-contain drop-shadow" />
              </div>
            </div>
            <div className="leading-none">
              <span className="text-white font-extrabold text-sm tracking-[0.06em] block">HEXAFUND</span>
              <span className="text-[#2563EB] text-[9px] tracking-[0.2em] uppercase font-semibold block mt-0.5">Crowd Funding</span>
            </div>
          </div>
          <button onClick={() => setOpen(false)}
            className="lg:hidden w-8 h-8 rounded-lg flex items-center justify-center border border-[#1e3a5f]/60 hover:border-[#2563EB]/40 text-[#475569] hover:text-[#7DD3FC] transition-all duration-200">
            <KeyboardDoubleArrowLeftIcon fontSize="small" />
          </button>
        </div>

        {/* ── MENU LABEL ── */}
        <p className="relative z-10 text-[9px] font-bold uppercase tracking-[0.3em] text-[#334155] px-5 pt-5 pb-2 flex-shrink-0">
          Navigation
        </p>

        {/* ── MENU ── */}
        <nav className="relative z-10 flex-1 px-3 overflow-y-auto sidebar-scroll space-y-0.5 pb-2">
          {menu.map((item, i) => {
            const active = isMenuActive(item);
            const hasSubmenu = !!item.submenu;
            const isOpen = openSubmenu === i;

            return (
              <div key={i}>
                <div
                  onClick={() => {
                    if (hasSubmenu) {
                      setOpenSubmenu(isOpen ? null : i);
                    } else if (item.action) {
                      item.action();
                      setOpen(false);
                    } else if (item.path) {
                      navigate(item.path);
                      setOpen(false);
                    }
                  }}
                  className={`group relative flex items-center gap-3 px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 select-none
                    ${active
                      ? "text-white"
                      : "text-[#64748B] hover:text-[#CBD5E1] hover:bg-white/4"
                    }`}
                  style={active ? {
                    background: "linear-gradient(90deg, rgba(37,99,235,0.18) 0%, rgba(29,78,216,0.08) 100%)",
                    borderLeft: "2px solid #2563EB",
                  } : {}}
                >
                  {/* Icon */}
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-200
                    ${active
                      ? "bg-gradient-to-br from-[#2563EB] to-[#1D4ED8] shadow-[0_0_12px_rgba(37,99,235,0.4)] text-white"
                      : "bg-white/5 text-[#475569] group-hover:bg-[#2563EB]/12 group-hover:text-[#7DD3FC]"
                    }`}>
                    <span className="text-base">{item.icon}</span>
                  </div>

                  {/* Label */}
                  <span className={`text-xs font-semibold flex-1 transition-all duration-200 ${active ? "text-white" : ""}`}>
                    {item.title}
                  </span>

                  {/* Submenu arrow */}
                  {hasSubmenu && (
                    <svg className={`w-3.5 h-3.5 flex-shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180 text-[#2563EB]" : "text-[#334155]"}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}

                  {/* Active dot */}
                  {!hasSubmenu && active && (
                    <span className="w-1.5 h-1.5 rounded-full bg-[#22D3EE] flex-shrink-0" />
                  )}
                </div>

                {/* Submenu */}
                {hasSubmenu && isOpen && (
                  <div className="ml-5 mt-0.5 mb-1 pl-3 border-l border-[#1e3a5f]/50 space-y-0.5">
                    {item.submenu.map((sub, j) => {
                      const subActive = isPathActive(sub.path);
                      return (
                        <div key={j}
                          onClick={() => {
                            if (sub.action) sub.action();
                            else if (sub.path) navigate(sub.path);
                            setOpen(false);
                          }}
                          className={`group flex items-center gap-2.5 px-2.5 py-2 rounded-lg cursor-pointer transition-all duration-150
                            ${subActive
                              ? "bg-[#2563EB]/15 text-white"
                              : "text-[#475569] hover:text-[#CBD5E1] hover:bg-white/4"
                            }`}
                        >
                          <span className={`text-sm transition-colors duration-150 ${subActive ? "text-[#22D3EE]" : "text-[#334155] group-hover:text-[#7DD3FC]"}`}>
                            {sub.icon}
                          </span>
                          <span className="text-[11px] font-medium">{sub.title}</span>
                          {subActive && <span className="ml-auto w-1 h-1 rounded-full bg-[#22D3EE]" />}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* ── LOGOUT ── */}
        <div className="relative z-10 px-3 pb-4 pt-2 border-t border-[#1e3a5f]/40 flex-shrink-0">
          <button
            onClick={() => { localStorage.clear(); navigate("/"); }}
            className="group w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border border-red-500/20 hover:border-red-500/40 text-red-400/70 hover:text-red-300 transition-all duration-200 hover:bg-red-500/8"
          >
            <div className="w-8 h-8 rounded-lg bg-red-500/10 group-hover:bg-red-500/20 flex items-center justify-center transition-all duration-200 flex-shrink-0">
              <FaSignOutAlt className="text-sm" />
            </div>
            <span className="text-xs font-semibold">Logout</span>
          </button>
          <p className="text-center text-[#1e3a5f] text-[10px] mt-3 tracking-widest">v1.0.0</p>
        </div>

        <style>{`
          .sidebar-scroll::-webkit-scrollbar { width: 3px; }
          .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
          .sidebar-scroll::-webkit-scrollbar-thumb { background: rgba(37,99,235,0.3); border-radius: 3px; }
          .sidebar-scroll::-webkit-scrollbar-thumb:hover { background: rgba(37,99,235,0.6); }
        `}</style>
      </aside>
    </>
  );
};

export default Sidebar;
